<template>
    <div class="blank">
        <div class="banner">
            <!--<img class="logo" src="/img/lawUnion/logo.png"/>-->
            <h1 style="text-align: center;color: #fff;padding-top: 0.2rem;">商业公司联盟</h1>
        </div>
        <div class="center" style="background-color: #f7f7f7;">
            <div class="formFillin">
                <p class="nameWorde">申请名称</p>
                <input type="text" placeholder="请输入申请名称" class="inputWorde" v-model="orgname"/>
                <p class="nameWorde">联系人姓名</p>
                <input type="text" placeholder="请输入联系人姓名" class="inputWorde" v-model="linkname"/>
                <p class="nameWorde">联系电话</p>
                <input type="text" placeholder="请输入联系电话" class="inputWorde" v-model="linktel"/>
                <p class="nameWorde">联系邮箱</p>
                <input type="text" placeholder="请输入联系邮箱" class="inputWorde" v-model="linkemail"/>
                <p class="nameWorde">联系地址</p>
                <input type="text" placeholder="请输入联系地址" class="inputWorde" v-model="linkaddress"/>
                <div class="center">
                    <div class="submission" @click="submission()">提交申请</div>
                </div>
            </div>
            <div style="font-size: 0.24rem;padding: 0.27rem 0;">
                <router-link to="unionList" style="color: #999999;">已有<span style="color: red;">{{mu}}</span>申请</router-link>
                <div class="inline-block" style="margin-left: 0.3rem;">   蜀ICP备18027673号</div>
                <!--<div class="inline-block" @click="eject()">《什么是公益法律服务联盟》</div>-->
            </div>
        </div>
        <!--弹出-->
        <div class="el-alert1" v-if="display">
            <div class="whiteboard">
                <div class="title">公益法律服务联盟</div>
                <div class="word">
                    <p><span style="font-weight: bold;">1、发起者： </span><p style="font-size: 0.3rem;">公益法律服务联盟由微律名片、律所、律师等成员共同发起，是首个法律行业公益组织。</p></p>
                    <p><span style="font-weight: bold;">2、联盟宗旨： </span><p style="font-size: 0.3rem;">整合法律界资源，针对需要帮助的人们（农民工、残疾人、老年人、妇女家庭、未成年人）提供法律咨询法律援助服务。</p></p>
                    <p><span style="font-weight: bold;">3、联盟成员获得： </span><p style="font-size: 0.3rem;">“微律名片”的公益案件专区联盟成员展示。</p></p>
                    <p class="center" style="font-size: 0.3rem;">“微律名片”的案源中心优先配发权。</p>
                    <img style="width: 100%;height: 100%;margin-top: 0.3rem;" src="/img/lawUnion/w.jpg">
                </div>
                <div class="close" @click="eject()">关闭</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "blank",
        data () {
            return {
                display : false,
                orgname:'',
                linkname:'',
                linktel:'',
                linkemail:'',
                linkaddress:'',
                fullscreenLoading: false,
                mu: ''
            }
        },
        methods :{
            eject:function(){
                var _this = this
                _this.display = !_this.display
            },
            submission : function () {
                var _this = this
                _this.send({
                    server : 'ai',
                    url : '/orgAdd',
                    data: {orgname:_this.orgname, linkname:_this.linkname, linktel:_this.linktel, linkemail:_this.linkemail, linkaddress:_this.linkaddress,},
                    success: function (res) {
                        if(res.status == false){
                            _this.$message.error(res.msg);
                        }else {
                            _this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            sessionStorage.type = 1
                            _this.$router.push({path:'/unionList'});
                            // this.$router.push({path:'/testDemo',query:{setid:''}});
                        }

                    }
                })
            },
            openFullScreen() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 2000);
            }
        },
        mounted () {
            var _this = this
            this.send({
                server : 'ai',
                url : '/orgCount',
                success: function (res) {
                    _this.mu = res.data
                }
            })
        },
    }
</script>

<style scoped>
    .banner{width: 7.5rem;height: 3.6rem;background: url("/img/lawUnion/banner.png");background-size: 7.5rem 3.6rem;position: relative;}
    .logo{width: 3.84rem;height: 1.92rem;position: absolute;top: 0.5rem;left: 50%;margin-left: -1.9rem;}
    .formFillin{width: 6.9rem;background-color: #fff;border-radius: 0.04rem;margin-top: -0.65rem;position: relative;text-align: center;display: inline-block;box-shadow: 0px 0px 0.15rem -0.05rem #888888;}
    .nameWorde{font-size: 0.28rem;color: #333333;text-align: left;margin: 0.25rem 0 0 0.3rem;}
    .inputWorde{font-size: 0.28rem;color: #c7cbd5;border-bottom: 0.01rem solid #dddddd;width: 6.3rem;height: 1rem;}
    .submission{width: 4.6rem;height: 0.8rem;color: #FFF;background-color: #4e79f4;font-size: 0.3rem;text-align: center; line-height: 0.8rem;border-radius: 0.4rem;display: inline-block;margin: 0.3rem 0;}
    /*弹出*/
    .el-alert1{background-color: rgba(0,0,0,0.3);position: fixed;width: 100%;height: 100%;top: 0;display: flex;}
    .whiteboard{width: 5.7rem;background-color: #fff;position: absolute;left: 50%;margin-left: -2.85rem;align-self: center;}
    .title{font-size: 0.3rem;color: #454545;line-height: 1rem;border-bottom: 0.01rem solid #dddddd;text-align: center}
    .word{font-size: 0.26rem;color: #454545;padding: 0.3rem 0.3rem 0.51rem}
    .close{width: 1.77rem;height: 0.6rem;background-color: #4e79f4;border-radius: 0.3rem;color: #FFF;text-align: center;line-height: 0.6rem;position: absolute;bottom: -0.3rem;left: 50%;margin-left: -0.885rem;}
</style>
